import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/custom.css';
import './styles/bootstrap-custom.scss';
import './bootstrap'; // Import our optimized bootstrap components
import 'bootstrap-icons/font/bootstrap-icons.css';
import App from './App';

// Log environment variables in development to help with debugging
if (process.env.NODE_ENV === 'development') {
  console.log('Development environment detected');
  console.log('Environment variables available to React:');
  Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')).forEach(key => {
    console.log(`${key}: ${process.env[key]}`);
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
